import React, { useEffect, useState } from 'react';
import { ExternalLink, FileSpreadsheet, Loader2, Lock, Pencil, Save, X } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { serviceDeliveryAPI } from '../lib/api';

export const AdsOptimizationSheetCard = ({ clientId }) => {
  const [link, setLink] = useState(null);
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState({ url: '', name: '' });
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (clientId) serviceDeliveryAPI.getAdsSheet(clientId).then(setLink).catch(() => setLink({ url: '', name: '' })); }, [clientId]);

  const save = async () => {
    setSaving(true);
    try { const r = await serviceDeliveryAPI.setAdsSheet(clientId, form); setLink(r); setEdit(false); toast.success(r.url ? 'Enlace guardado' : 'Enlace quitado'); }
    catch (e) { toast.error(e.message); } finally { setSaving(false); }
  };
  if (!link) return null;

  return (
    <Card className="border-dashed" data-testid="ads-sheet-card">
      <CardContent className="py-3 flex items-center gap-3 flex-wrap">
        <FileSpreadsheet className="w-5 h-5 text-emerald-600 shrink-0" />
        {edit ? (
          <>
            <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nombre (p. ej. Optimización semanal)" className="h-9 w-56" data-testid="ads-sheet-name-input" />
            <Input value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} placeholder="https://docs.google.com/spreadsheets/..." className="h-9 flex-1 min-w-[240px]" data-testid="ads-sheet-url-input" />
            <Button size="sm" onClick={save} disabled={saving} data-testid="ads-sheet-save-btn">{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}</Button>
            <Button size="sm" variant="ghost" onClick={() => setEdit(false)} data-testid="ads-sheet-cancel-btn"><X className="w-4 h-4" /></Button>
          </>
        ) : link.url ? (
          <>
            <a href={link.url} target="_blank" rel="noreferrer" className="font-medium text-sm hover:underline inline-flex items-center gap-1" data-testid="ads-sheet-link">{link.name}<ExternalLink className="w-3.5 h-3.5" /></a>
            <span className="text-xs text-muted-foreground inline-flex items-center gap-1"><Lock className="w-3 h-3" />Interno · solo CEOs</span>
            <Button size="sm" variant="ghost" className="ml-auto" onClick={() => { setForm({ url: link.url, name: link.name }); setEdit(true); }} data-testid="ads-sheet-edit-btn"><Pencil className="w-4 h-4" /></Button>
          </>
        ) : (
          <>
            <span className="text-sm text-muted-foreground">Informe semanal de optimización (Google Sheet). Interno, solo lo veis las CEOs.</span>
            <Button size="sm" variant="outline" className="ml-auto" onClick={() => { setForm({ url: '', name: 'Informe semanal de optimización' }); setEdit(true); }} data-testid="ads-sheet-add-btn">Añadir enlace</Button>
          </>
        )}
      </CardContent>
    </Card>
  );
};
